module.exports = __webpack_public_path__ + "static/media/isha-rajput.281f21cc.png";